import React, { useEffect, useState, useRef } from "react";
import {
  Table,
  Tag,
  Button as Buttons,
  Space,
  Modal,
  Select,
  InputRef,
  TableColumnType,
  Input,
  Button,
  Popconfirm,
  Form,
  Card,
  Row,
  Col,
  Typography,
} from "antd";
import type { TableColumnsType } from "antd";
import type { TableProps } from "antd";
import EventController from "../../pages/Admin/Controller/event_controller.ts";
import { BellOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import MyDocument from "../../pages/Admin/pdf/event-invoice.tsx";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { notification } from "antd";
import type { FilterDropdownProps } from "antd/es/table/interface";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import EventRegistrationExcel from "../../pages/Admin/excel/event_registration_list_excel.jsx";
const { Title } = Typography;
const { Option } = Select;

interface DataType {
  key: React.Key;
  event_registrationID: string;
  company_name: string;
  hrd_claim_status: number;
  payment_status: number;
  address: string;
  description: string;
  paymentID: string;
  registration_start_date: string;
  registration_end_date: string;
  early_bird_start_date: string;
  early_bird_end_date: string;
  payment_datetime_created: string;
  invoice_no: string;
  event_name: string;
  early_bird_price: string;
  registration_price: string;
  event_categoryID: string;
  invitation_status: number;
  public_beneficiary_ids: string;
  public_beneficiary_fullnames: any;
  public_beneficiary_emails: any;
  public_beneficiary_phones: any;
  public_beneficiary_dietary_restriction: any;
  public_beneficiary_designations: any;
  contact_salutation: string;
  contact_name: string;
  contact_hp: any;
  contact_email: any;
  billing_name: string;
  billing_address: any;
}

type DataIndex = keyof DataType;

interface ExpandedDataType {
  key: React.Key;
  event_registrationID: string;
  name: string;
  email: string;
  //   payment_status: number;
  //   address: string;
  //   description: string;
}

interface AntdTableProps extends TableProps<DataType> {
  eventID: string | number; // Define the type of data you want to pass
}

const App: React.FC<AntdTableProps> = ({ eventID }) => {
  const handleSendEventRegistrationReminder = (record) => {
    const payload = {
      eventID: eventID,
      data: record,
    };
    console.log(payload);
    // EventController.sendEventRegistrationPaymentReminder(payload).then(
    //   (response) => {
    //     if (response.status === "success") {
    //       openNotificationWithIcon(
    //         "success",
    //         "Email reminder has been sent!",
    //         "Success"
    //       );
    //     }
    //   }
    // );
  };
  const expandColumns = [
    {
      title: "No.",
      dataIndex: "index",
      key: "index",
      width: "10%",
      render: (_: any, __: ExpandedDataType, index: number) => index + 1, // Increment by 1 to start numbering from 1
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    // {
    //   title: "Action",
    //   key: "action",
    //   render: (_, record) => (
    //     <Space size="middle">
    //       {/* <Buttons
    //         icon={<BellOutlined />}
    //         onClick={() => handleSendEventRegistrationReminder(record)} // Copy URL on click
    //         style={{ marginTop: "10px" }}
    //       >
    //         Alert Payment
    //       </Buttons> */}
    //     </Space>
    //   ),
    // },
  ];

  const [data, setData] = useState<DataType[]>([]);
  const [dataBeneficiary, setDataBeneficiary] = useState<ExpandedDataType[]>(
    []
  );
  // const [shouldRefetchData, setShouldRefetchData] = useState(false);

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, desc, msg) => {
    api[type]({
      message: msg,
      description: desc,
    });
  };

  const userID = localStorage.getItem("userID");

  const delete_record = (rowId: string, userID) => {
    const payload = new FormData();
    payload.append("ID", rowId); // Append event ID
    payload.append("userID", userID); // Append event ID

    console.log(rowId);
    console.log(userID);

    EventController.deleteEventRegistrationRow(payload).then((response) => {
      console.log(response);
      if (response?.status === "success") {
        openNotificationWithIcon(
          "success",
          "Your data has been deleted successfully!",
          "Success"
        );
        setRefreshKey((prev) => !prev); // Toggle to re-trigger useEffect
      }
    });
  };

  // **************************** SEARCH FILTER ANTD TABLE *****************************************************

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<InputRef>(null);

  const handleSearch = (
    selectedKeys: string[],
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex
  ) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters: () => void) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (
    dataIndex: DataIndex
  ): TableColumnType<DataType> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys as string[], confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText((selectedKeys as string[])[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownOpenChange: (open) => {
      if (open) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  // ************************************************************************************************************
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState<DataType | null>(null);
  const [form] = Form.useForm();

  // const showEditModal = (record: DataType) => {
  //   setSelectedRow(record); // Set the selected row data
  //   setIsEditModalOpen(true); // Open modal
  // };
  const showEditModal = (record: DataType) => {
    setSelectedRow(record);
    setIsEditModalOpen(true);

    const beneficiaries =
      record.public_beneficiary_fullnames?.map((name, index) => ({
        fullname: name,
        email: record.public_beneficiary_emails[index] || "",
        phone: record.public_beneficiary_phones[index] || "",
        id: record.public_beneficiary_ids[index] || "",
        designation: record.public_beneficiary_designations[index] || "",
        dietary: record.public_beneficiary_dietary_restriction[index] || 0,
      })) || [];

    // Set form values manually
    form.setFieldsValue({
      ...record,
      public_beneficiaries: beneficiaries,
    });
  };

  const handleCloseModal = () => {
    setIsEditModalOpen(false);
    setSelectedRow(null); // Reset selected row when closing
    form.resetFields(); // Clear the form data
  };

  const defaultColumns: TableColumnsType<DataType> = [
    {
      title: "No.",
      dataIndex: "index",
      key: "index",
      width: "10%",
      render: (_: any, __: DataType, index: number) => index + 1, // Increment by 1 to start numbering from 1
    },
    {
      title: "Event Registration ID",
      dataIndex: "event_registrationID",
      key: "event_registrationID",
    },
    Table.EXPAND_COLUMN,
    {
      title: "Registered Members",
      dataIndex: "company_name",
      key: "company_name",
      ...getColumnSearchProps("company_name"),
    },
    {
      title: "HRD Claim",
      dataIndex: "hrd_claim_status",
      key: "hrd_claim_status",
      filters: [
        { text: "HRD Claim", value: '1' },
        { text: "No HRD Claim", value: '0' },
      ],
      onFilter: (value, record) => record.hrd_claim_status === value,
      render: (hrd_claim_status) => (
        <Tag color={hrd_claim_status === '1' ? "green" : "red"}>
          {hrd_claim_status === '1' ? "HRD Claim" : "No HRD Claim"}
        </Tag>
      ),
    },
    {
      title: "Payment Status",
      dataIndex: "payment_status",
      key: "payment_status",
      filters: [
        { text: "Pending", value: 0 },
        { text: "Paid", value: 1 },
        { text: "Unpaid", value: 2 },
        { text: "HRDC Grant", value: 3 },
        { text: "HRDC Paid", value: 4 },
      ],
      onFilter: (value, record) => record.payment_status === value,
      render: (payment_status: any, record: DataType) => {
        if (record.paymentID === null) {
          return <Tag color="blue">Free</Tag>;
        }

        const statusMap = {
          "0": { color: "orange", text: "Pending" },
          "1": { color: "green", text: "Paid" },
          "2": { color: "red", text: "Unpaid" },
          "3": { color: "blue", text: "HRDC Grant" },
          "4": { color: "purple", text: "HRDC Paid" },
        };

        // Get color and text based on payment_status
        const { color, text } = statusMap[payment_status] || {
          color: "gray",
          text: "Unknown",
        };

        return (
          <Tag color={color} key={payment_status}>
            {text}
          </Tag>
        );
      },
    },
    {
      title: "Operation",
      dataIndex: "operation",
      width: 150,
      render: (_: any, record: DataType) => (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Button
            type="default"
            icon={<EditOutlined />}
            onClick={() => showEditModal(record)} // Pass row data
            style={{ marginBottom: 7 }}
          >
            Edit
          </Button>
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => delete_record(record.event_registrationID, userID)}
          >
            <Button type="primary" danger icon={<DeleteOutlined />}>
              Delete
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  const columnsForCategory5: TableColumnsType<DataType> = [
    {
      title: "No.",
      dataIndex: "index",
      key: "index",
      render: (_: any, __: DataType, index: number) => index + 1, // Increment by 1 to start numbering from 1
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Committee Type",
      dataIndex: "committee_type",
      key: "committee_type",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (invitation_status: any, record: DataType) => {
        const getStatusProps = (status: number) => {
          switch (status) {
            case 0:
              return { color: "yellow", text: "Pending" };
            case 1:
              return { color: "green", text: "Accepted" };
            case 2:
              return { color: "red", text: "Declined" };
            default:
              return { color: "gray", text: "Unknown" }; // Fallback for unexpected statuses
          }
        };

        const { color, text } = getStatusProps(record.invitation_status);

        return (
          <Tag color={color} key={record.invitation_status}>
            {text}
          </Tag>
        );
      },
    },

    // Add more custom columns here for categoryID 5
  ];

  const columnsForCategory10: TableColumnsType<DataType> = [
    {
      title: "No.",
      dataIndex: "index",
      key: "index",
      width: "10%",
      render: (_: any, __: DataType, index: number) => index + 1, // Increment by 1 to start numbering from 1
    },
    {
      title: "Event Registration ID",
      dataIndex: "event_registrationID",
      key: "event_registrationID",
    },
    Table.EXPAND_COLUMN,
    {
      title: "Registered Members",
      dataIndex: "company_name",
      key: "company_name",
      ...getColumnSearchProps("company_name"),
    },
    {
      title: "Payment Status",
      dataIndex: "payment_status",
      key: "payment_status",
      filters: [
        { text: "Pending", value: 0 },
        { text: "Paid", value: 1 },
        { text: "Unpaid", value: 2 },
        { text: "HRDC Grant", value: 3 },
        { text: "HRDC Paid", value: 4 },
      ],
      onFilter: (value, record) => record.payment_status === value,
      render: (payment_status: any, record: DataType) => {
        if (record.paymentID === null) {
          return <Tag color="blue">Free</Tag>;
        }

        const statusMap = {
          "0": { color: "orange", text: "Pending" },
          "1": { color: "green", text: "Paid" },
          "2": { color: "red", text: "Unpaid" },
          "3": { color: "blue", text: "HRDC Grant" },
          "4": { color: "purple", text: "HRDC Paid" },
        };

        // Get color and text based on payment_status
        const { color, text } = statusMap[payment_status] || {
          color: "gray",
          text: "Unknown",
        };

        return (
          <Tag color={color} key={payment_status}>
            {text}
          </Tag>
        );
      },
    },
    {
      title: "Operation",
      dataIndex: "operation",
      width: 150,
      render: (_: any, __: DataType) => (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => delete_record(__.event_registrationID, userID)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              style={{ marginBottom: 7 }}
            >
              Delete
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ];

  const columnsForCategory16: TableColumnsType<DataType> = [
    {
      title: "No.",
      dataIndex: "index",
      key: "index",
      render: (_: any, __: DataType, index: number) => index + 1, // Increment by 1 to start numbering from 1
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Member Type",
      dataIndex: "member_type",
      key: "member_type",
    },

    // Add more custom columns here for categoryID 5
  ];

  const [refreshKey, setRefreshKey] = React.useState(false); // Add a state for triggering useEffect

  const [subRows, setSubRows] = useState<any[]>([]);
  const [columns, setColumns] =
    useState<TableColumnsType<DataType>>(defaultColumns);
  const [eventCategoryID, setEventCategoryID] = useState<number | null>(null);

  useEffect(() => {
    EventController.getEventRegistrationInfo(eventID).then((data) => {
      console.log(data);
      const row = data.map((item, index) => {
        return {
          key: index,
          event_registrationID: item.event_registrationID,
          nric: item.nric,
          email: item.email,
          handphone_no: item.handphone_no,
          company_name: item.company_name || item.contact_name,
          hrd_grant_status: item.hrd_grant_status,
          hrd_claim_status: item.hrd_claim_status,
          payment_status: item.payment_status,
          address: item.address,
          description: item.description,
          paymentID: item.paymentID,
          registration_start_date: item.registration_start_date,
          registration_end_date: item.registration_end_date,
          early_bird_start_date: item.early_bird_start_date,
          early_bird_end_date: item.early_bird_end_date,
          payment_datetime_created: item.payment_datetime_created,
          invoice_no: item.invoice_no,
          event_name: item.event_name,
          registration_price: item.event_fee.normal_rate,
          early_bird_price: item.event_fee.early_bird_rate,
          beneficiaryIDs: item.beneficiaryIDs,
          // Split comma-separated values into arrays
          public_beneficiary_ids: item.public_beneficiary_ids
            ? item.public_beneficiary_ids.split(",")
            : [],
          public_beneficiary_fullnames: item.public_beneficiary_fullnames
            ? item.public_beneficiary_fullnames.split(",")
            : [],
          public_beneficiary_emails: item.public_beneficiary_emails
            ? item.public_beneficiary_emails.split(",")
            : [],
          public_beneficiary_phones: item.public_beneficiary_phones
            ? item.public_beneficiary_phones.split(",")
            : [],
          public_beneficiary_designations: item.public_beneficiary_designations
            ? item.public_beneficiary_designations.split(",")
            : [],
          public_beneficiary_dietary_restriction:
            item.public_beneficiary_dietary_restriction
              ? item.public_beneficiary_dietary_restriction.split(",")
              : [],
          event_categoryID: item.event_categoryID,
          name: item.name,
          committee_type: item.label,
          invitation_status: item.invitation_status,
          member_type: item.member_type,
          contact_salutation: item.contact_salutation,
          contact_name: item.contact_name,
          contact_hp: item.contact_hp,
          contact_email: item.contact_email,
          billing_name: item.billing_name,
          billing_address: item.billing_address,
        };
      });

      setData(row);

      // Set eventCategoryID state
      if (data.length > 0) {
        setEventCategoryID(data[0].event_categoryID);
      }

      // Determine which columns to use
      if (data.length > 0 && Number(data[0].event_categoryID) === 5) {
        setColumns(columnsForCategory5);
      } else if (data.length > 0 && Number(data[0].event_categoryID) === 10) {
        setColumns(columnsForCategory10);
      } else {
        setColumns(defaultColumns);
      }

      const subRowArray = data.map((item, index) => {
        return item.beneficiary.map((item1) => ({
          key: index,
          event_registrationID: item1.event_registrationID,
          name: item1.name,
          email: item1.email,
        }));
      });

      const flattenedSubRows = subRowArray.flat();

      setSubRows(flattenedSubRows);
    });
  }, [eventID, refreshKey]);

  const expandedRowRender = (record: DataType) => {
    const eventRegistrationID = record.event_registrationID;

    const expandDataSource = subRows
      .filter((item) => item.event_registrationID === eventRegistrationID)
      .map((item, index) => {
        return {
          key: index,
          event_registrationID: item.event_registrationID,
          name: item.name,
          email: item.email,
        };
      });

    return (
      <Table<ExpandedDataType>
        columns={expandColumns}
        dataSource={expandDataSource}
        pagination={false}
        scroll={{ x: "100vh" }}
      />
    );
  };

  // const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<DataType[]>([]);
  const [paymentBtnState, setPaymentBtnState] = useState(true);
  const [updatePaymentStatusValue, setUpdatePaymentStatusValue] = useState("");

  const rowSelectionConst = {
    onChange: (keys: React.Key[], rows: DataType[]) => {
      setSelectedRows(rows);

      rows.length > 0 ? setPaymentBtnState(false) : setPaymentBtnState(true);
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
    const paymentIDs = selectedRows.map((item, index) => {
      return item.paymentID;
    });
    const eventRegistrationIDs = selectedRows.map((item, index) => {
      return item.event_registrationID;
    });
    const payload = {
      userID: userID,
      value: updatePaymentStatusValue,
      paymentIDs: paymentIDs,
      eventRegistrationIDs: eventRegistrationIDs,
    };

    EventController.updateEventRegistrationPaymentInfo(payload).then(
      (response) => {
        if (response.status === "success") {
          setRefreshKey((prevKey) => !prevKey);
          openNotificationWithIcon(
            "success",
            "Your data has been saved successfully!",
            "Success"
          );
        }
      }
    );
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleSelectChange = (value: string) => {
    setUpdatePaymentStatusValue(value);
  };

  const dietaryOptions = [
    { value: "1", label: "Vegetarian" },
    { value: "0", label: "Non-Vegetarian" },
  ];

  const handleEditSubmit = async (values, userID) => {
    const payload = new FormData();
    payload.append("userID", userID);

    console.log(userID);
    payload.append(
      "event_registrationID",
      selectedRow?.event_registrationID ?? ""
    );
    // payload.append("userID", userID); // Append user ID

    // Manually append fields except excluded ones
    Object.keys(values).forEach((field) => {
      if (field !== "hrd_claim_status" && field !== "public_beneficiaries") {
        payload.append(`data[${field}]`, values[field]);
      }
    });

    payload.append("hrd_claim_status", values.hrd_claim_status);

    // Format and append public_beneficiaries fields as comma-separated values
    if (values.public_beneficiaries) {
      payload.append(
        "public_beneficiary_fullnames",
        values.public_beneficiaries.map((p) => p.fullname).join(",")
      );
      payload.append(
        "public_beneficiary_ids",
        values.public_beneficiaries.map((p) => p.id).join(",")
      );
      payload.append(
        "public_beneficiary_emails",
        values.public_beneficiaries.map((p) => p.email).join(",")
      );
      payload.append(
        "public_beneficiary_phones",
        values.public_beneficiaries.map((p) => p.phone).join(",")
      );
      payload.append(
        "public_beneficiary_designations",
        values.public_beneficiaries.map((p) => p.designation).join(",")
      );
      payload.append(
        "public_beneficiary_dietary_restriction",
        values.public_beneficiaries.map((p) => p.dietary).join(",")
      );
    }

    // 🔹 Debugging: Log FormData contents before submitting
    // for (const pair of payload.entries()) {
    //   console.log(pair[0], pair[1]);
    // }

    // 🔹 Send to API
    try {
      const response = await EventController.UpdateEventRegistrationInfo(
        payload
      );
      if (response?.status === "success") {
        openNotificationWithIcon(
          "success",
          "Your registration has been updated successfully!",
          "Success"
        );
        setRefreshKey((prevKey) => !prevKey);
        setIsEditModalOpen(false); // Close modal on success
      }
    } catch (error) {
      console.error("Error updating registration:", error);
    }
  };

  return (
    <>
      {!(eventCategoryID == 5 || eventCategoryID == 16) ? (
        <>
          <div
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Buttons
              disabled={paymentBtnState}
              onClick={showModal}
              icon={<EditOutlined />}
              style={{ marginBottom: "20px" }}
            >
              Update Payment
            </Buttons>

            <EventRegistrationExcel eventID={eventID} />
          </div>
          {contextHolder}
          <Modal
            title="Update Payment"
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            okText="Save"
            okButtonProps={{
              style: { backgroundColor: "#d33333" },
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <label
                style={{
                  fontSize: "16px",
                  fontWeight: "bold",
                  minWidth: "120px",
                }}
              >
                Payment Status:
              </label>
              <Select
                style={{ flex: 1 }}
                onChange={handleSelectChange}
                options={[
                  { value: "0", label: "Pending" },
                  { value: "1", label: "Paid" },
                  { value: "2", label: "Unpaid" },
                  { value: "3", label: "HRDC Grant" },
                  { value: "4", label: "HRDC Paid" },
                ]}
                placeholder="Select Payment Status"
              />
            </div>
          </Modal>
          {/* Edit Modal */}
          <Modal
            open={isEditModalOpen}
            onCancel={handleCloseModal}
            footer={null}
            width={900} // Adjust modal width
          >
            <Title level={2}>
              Edit Event Registration({selectedRow?.event_registrationID})
            </Title>
            <Form
              form={form}
              layout="vertical"
              onFinish={(values) => handleEditSubmit(values, userID)}
            >
              {/*Billing Info */}
              <Title level={4}>Billing Info</Title>
              <Card style={{ marginBottom: 20, borderRadius: 10 }}>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      label="Billing Name"
                      name="billing_name"
                      // rules={[{ required: true }]}
                    >
                      <Input defaultValue={selectedRow?.billing_name} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24}>
                    <Form.Item label="Billing Address" name="billing_address">
                      <Input defaultValue={selectedRow?.billing_address} />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>

              {/*Contact Person Info */}
              <Title level={4}>Contact Person Info</Title>
              <Card style={{ marginBottom: 20, borderRadius: 10 }}>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      label="Contact Person Salutation"
                      name="contact_salutation"
                      // rules={[{ required: true }]}
                    >
                      <Input defaultValue={selectedRow?.contact_salutation} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      label="Contact Person Name"
                      name="contact_name"
                      // rules={[{ required: true }]}
                    >
                      <Input defaultValue={selectedRow?.contact_name} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item label="Mobile No." name="contact_hp">
                      <Input defaultValue={selectedRow?.contact_hp} />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Form.Item label="Email Address" name="contact_email">
                      <Input defaultValue={selectedRow?.contact_email} />
                    </Form.Item>
                  </Col>
                </Row>
              </Card>

              {/* HRD CORP GRANT */}
              <Title level={4}>HRD CORP GRANT</Title>
              <Card style={{ marginBottom: 20, borderRadius: 10 }}>
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={12}>
                    <Form.Item
                      label="Are you applying for HRD Corp Grant?"
                      name="hrd_claim_status"
                    >
                      <Select defaultValue={selectedRow?.hrd_claim_status}>
                        <Option value={1}>Yes</Option>
                        <Option value={0}>No</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              </Card>

              {/* Participants Section */}
              <Title level={4}>Participants Info</Title>
              <Form.List name="public_beneficiaries">
                {(fields) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Card
                        key={key}
                        style={{ marginBottom: 15, borderRadius: 10 }}
                      >
                        <Title level={5} style={{ marginBottom: 10 }}>
                          Participant {key + 1}
                        </Title>
                        <Row gutter={[16, 16]}>
                          <Col xs={24} sm={12}>
                            <Form.Item
                              {...restField}
                              label="Full Name"
                              name={[name, "fullname"]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Form.Item
                              {...restField}
                              label="NRIC"
                              name={[name, "id"]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Form.Item
                              {...restField}
                              label="Email"
                              name={[name, "email"]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Form.Item
                              {...restField}
                              label="Phone"
                              name={[name, "phone"]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Form.Item
                              {...restField}
                              label="Designation"
                              name={[name, "designation"]}
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Form.Item
                              {...restField}
                              label="Dietary"
                              name={[name, "dietary"]}
                            >
                              <Select>
                                {dietaryOptions.map((option) => (
                                  <Option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Card>
                    ))}
                  </>
                )}
              </Form.List>

              {/* Save Button */}
              <Form.Item style={{ textAlign: "right" }}>
                <Button type="primary" htmlType="submit">
                  Save Changes
                </Button>
              </Form.Item>
            </Form>
          </Modal>

          <Table<DataType>
            columns={columns}
            rowSelection={{
              type: "checkbox", // 'radio' for single selection
              ...rowSelectionConst,
              getCheckboxProps: (record) => ({
                disabled: record.paymentID === null, // Disable selection for "Free" rows
              }),
            }}
            expandable={{
              expandedRowRender,
            }}
            dataSource={data}
          />
        </>
      ) : (
        <Table<DataType> columns={columns} dataSource={data} />
      )}
    </>
  );
};

export default App;
